module.exports = require('react/lib/cloneWithProps');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-clone-with-props/index.js
// module id = 92
// module chunks = 0